export class DuplicateItemQfm {
    QfmTitle: string;
    QfmId: string;
    IsTemplate: boolean;

    constructor({
        QfmTitle,
        QfmId,
        IsTemplate
    } : {
        QfmTitle: string;
        QfmId: string;
        IsTemplate: boolean;
    }) {
        this.QfmTitle = QfmTitle;
        this.QfmId = QfmId;
        this.IsTemplate = IsTemplate;
    }
}